import * as React from "react";
import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import { Edit } from "@mui/icons-material";

export type EditIconButtonProps = {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    tooltip?: React.ReactNode;
    square?: boolean;
} & Omit<IconButtonProps, "onClick">;

export const EditIconButton = React.forwardRef<HTMLButtonElement, EditIconButtonProps>(
    ({ onClick, tooltip = "edit", square = false, size = "small", sx, ...rest }, ref) => {
        return (
            <Tooltip title={tooltip}>
                <span>
                    <IconButton
                        ref={ref}
                        onClick={onClick}
                        size={size}
                        sx={{

                            color: "action.active",
                            "&:hover": { color: "info.main" },
                            ...(square && { borderRadius: 1, px: 1 }),
                            ...sx,
                        }}
                        {...rest}
                    >
                        <Edit fontSize={size === "small" ? "small" : "medium"} />
                    </IconButton>
                </span>
            </Tooltip>
        );
    }
);

EditIconButton.displayName = "EditIconButton";
